import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import "./sidebar.css";

import AuthService from "../../services/auth.service";

import { useEffect } from "react";

const Sidebar = ({ menu, permissions }) => {
  const location = useLocation();

  const [menuD, setMenuD] = useState(false);
  const [roleid, setRoleid] = useState("");

  useEffect(() => {
    const user = AuthService.getCurrentUser();

    if (user) {
      setRoleid(user.role_id);
    }
  }, []);

  const isActiveDash =
    location.pathname.includes("/Dashboard") || location.pathname === "/";

  const isActiveOrg =
    location.pathname.includes("/ManageOrganisation") ||
    location.pathname.includes("/AddSubOrg") ||
    location.pathname.includes("/EditOrg") ||
    location.pathname.includes("/EditSubOrg");

  const isActiveAdmin =
    location.pathname.includes("/SystemManagers") ||
    location.pathname.includes("/EditSystemManagers") ||
    location.pathname.includes("/PresetRoles");

  const isActiveLearner =
    location.pathname.includes("/AllLearners") ||
    location.pathname.includes("/Cohorts") ||
    location.pathname.includes("/AddUser") ||
    location.pathname.includes("/EditLearner") ||
    location.pathname.includes("/AddCohort") ||
    location.pathname.includes("/EditCohort") ||
    location.pathname.includes("/ManageCohortParticipants");

  const isActiveCourses =
    location.pathname.includes("/ManageCourses") ||
    location.pathname.includes("/ManageParticipants") ||
    location.pathname.includes("/PathwayParticipants") ||
    location.pathname.includes("/EditCourse") ||
    location.pathname.includes("/ManagePathway") ||
    location.pathname.includes("/CreatePathway") ||
    location.pathname.includes("/EditPathway") ||
    location.pathname.includes("/CreateCourse") ||
    location.pathname.includes("/CourseDraft");

  const isActiveCalendar = location.pathname.includes("/Calendar");

  const isActiveReports =
    location.pathname.includes("/Reports") ||
    location.pathname.includes("/AddReport") ||
    location.pathname.includes("/ViewReport") ||
    location.pathname.includes("/ActivityLog") ||
    location.pathname.includes("/ActivityResult") ||
    location.pathname.includes("/CourseEnrollment") ||
    location.pathname.includes("/UserEnrollment") ||
    location.pathname.includes("/ViewReport") ||
    location.pathname.includes("/CertificateReports");

  const isActiveLearn =
    location.pathname.includes("/Learn") ||
    location.pathname.includes("/Course") ||
    location.pathname.includes("/Activity");
  const isActiveTrack = location.pathname.includes("/Track");
  const isActiveAchievements = location.pathname.includes("/Achievements");
  const isActiveCommunication = location.pathname.includes("/Communication");
  const isActiveHelpSupport = location.pathname.includes("/HelpNSupport");
  const isActiveCatalog = location.pathname.includes("/Catalog");

  const isActiveGuestdash = location.pathname.includes("/LandingPage");

  const isActiveGuestlogin = location.pathname.includes("/LandingPage");

  return (
    <>
      {location.pathname.includes("/CourseCatalog") ||
      location.pathname.includes("/CourseOverview") ? (
        <>
          <div className={menuD || menu ? "navigation active" : "navigation"}>
            <ul>
              <li className="logo">
                <Link to="/CourseCatalog">
                  <span className="icon icon__logo purple">
                    {/* <img src={Logo} width="40px" alt="" /> */}
                  </span>
                </Link>
              </li>
              <li
                className={
                  isActiveGuestdash ? "nav__list  active" : "nav__list"
                }
              >
                <Link to="/CourseCatalog" title="Dashboard">
                  <span className="icon icon_nav icon__dashboard">
                    <svg
                      id="Layer_2"
                      data-name="Layer 2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 34 34"
                    >
                      <g id="Layer_1" data-name="Layer 1">
                        <path
                          id="Path_11558"
                          data-name="Path 11558"
                          d="M0,17.465v-.93A4.717,4.717,0,0,1,1.532,14.16q6.319-6.286,12.605-12.6A4.745,4.745,0,0,1,16.535,0h.93a4.692,4.692,0,0,1,2.373,1.532q6.309,6.339,12.649,12.647A4.528,4.528,0,0,1,34,16.6v.8a.954.954,0,0,0-.057.151,3.1,3.1,0,0,1-3.091,2.576h-.5v.448c0,3.285.009,6.569-.008,9.854a3.62,3.62,0,0,1-2.553,3.4c-.209.066-.421.116-.632.173H21.051a1.178,1.178,0,0,1-.793-1.266c.016-2.531.009-5.063.006-7.594a1.678,1.678,0,0,0-1.822-1.814c-.94,0-1.879,0-2.819,0A1.692,1.692,0,0,0,13.733,25.2c0,2.509-.009,5.019.006,7.528A1.178,1.178,0,0,1,12.949,34H6.84a.282.282,0,0,0-.084-.047,3.717,3.717,0,0,1-3.121-3.824c.044-3.2.011-6.394.011-9.592v-.413c-.232,0-.418.009-.6,0a3.05,3.05,0,0,1-2.693-1.7A7.144,7.144,0,0,1,0,17.465Z"
                        />
                      </g>
                    </svg>
                  </span>
                </Link>
              </li>
              {/* <li
                className={
                  isActiveGuestlogin ? "nav__list active" : "nav__list"
                }
              >
                <Link to="/LandingPage" title="Course Catalog">
                  <span className="icon icon_nav icon__lern-path course-catalog-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="35"
                      viewBox="0 0 34.454 41.017"
                    >
                      <defs>
                        <clipPath id="clipPath">
                          <rect
                            id="Rectangle_179"
                            data-name="Rectangle 179"
                            width="34.454"
                            height="41.017"
                          />
                        </clipPath>
                      </defs>
                      <path
                        id="Exclusion_6"
                        data-name="Exclusion 6"
                        d="M16.662,31.241c-5.075,0-10.221-.011-15.3-.034a1.984,1.984,0,0,1-.872-.5A2,2,0,0,1,0,29.833V1.408A2,2,0,0,1,.494.53a1.983,1.983,0,0,1,.872-.5C6.441.011,11.586,0,16.662,0s10.222.011,15.3.034a1.983,1.983,0,0,1,.872.5,2,2,0,0,1,.494.878V29.833a1.883,1.883,0,0,1-1.367,1.374C26.882,31.23,21.736,31.241,16.662,31.241ZM9.76,6.365c-2.29,0-4.61,0-6.9,0a1.3,1.3,0,0,1-.228.268c-.043,7.161-.043,14.424,0,21.587l.033.041,0,0,.072.089.055.068c5.354.045,10.785.068,16.142.068,3.823,0,7.7-.012,11.519-.035a.587.587,0,0,0,.228-.235c.043-7.161.043-14.424,0-21.587L30.652,6.6l-.082-.085-.037-.038L30.46,6.4C23.6,6.377,16.637,6.365,9.76,6.365Zm-1.3-4.219h0a1.739,1.739,0,0,0-1.053.962,1.846,1.846,0,0,0,.24,1.451,1.667,1.667,0,0,0,1.107.531,1.585,1.585,0,0,0,1.171-.665A1.882,1.882,0,0,0,9.919,2.81a1.792,1.792,0,0,0-1.458-.664Zm-3.747.064-.158,0a1.515,1.515,0,0,0-.748,2.212A1.691,1.691,0,0,0,5,5.089a1.639,1.639,0,0,0,1.213-.732A1.908,1.908,0,0,0,6.11,2.724,1.644,1.644,0,0,0,4.714,2.209Zm7.485,0-.158,0a1.515,1.515,0,0,0-.748,2.212,1.689,1.689,0,0,0,1.193.66A1.646,1.646,0,0,0,13.7,4.358a1.908,1.908,0,0,0-.105-1.634A1.644,1.644,0,0,0,12.2,2.209Zm9.249,0c-.781,0-1.581,0-2.378,0a2.2,2.2,0,0,0-.879.6,1.714,1.714,0,0,0-.141,1.308A1.635,1.635,0,0,0,19,4.995c1.587.022,3.2.034,4.784.034s3.2-.011,4.784-.034a1.4,1.4,0,0,0,1.009-.7,1.671,1.671,0,0,0,.021-1.3,1.583,1.583,0,0,0-1.03-.747C26.208,2.221,23.811,2.208,21.448,2.208Zm3.243,23.271c-.679,0-1.367-.012-2.045-.037a.457.457,0,0,1-.228-.168c-.107-2.085-.129-4.205-.065-6.3a1.306,1.306,0,0,0,.228-.268c.46,0,.92,0,1.368,0,1.357,0,2.736.013,4.1.038l.076.078.019.02.089.091.044.046c.043,2.047.043,4.122,0,6.168a.469.469,0,0,1-.163.235C26.981,25.444,25.829,25.479,24.691,25.479Zm-8.653,0c-.679,0-1.367-.012-2.045-.037a.457.457,0,0,1-.228-.168c-.107-2.085-.129-4.206-.065-6.3a1.3,1.3,0,0,0,.228-.268c.46,0,.921,0,1.368,0,1.357,0,2.736.013,4.1.038l.228.235c.043,2.047.043,4.122,0,6.168a.469.469,0,0,1-.163.235C18.328,25.444,17.176,25.479,16.038,25.479Zm-8,0c-.9,0-1.805-.011-2.7-.034l-.03-.026L5.3,25.409l-.025-.022-.132-.113c-.075-2.112-.086-4.254-.033-6.369a2,2,0,0,1,.228-.2c.454,0,.909,0,1.352,0,1.34,0,2.7.013,4.05.038a.616.616,0,0,1,.163.1c.107,2.108.129,4.251.065,6.369l-.05.051-.013.014-.086.089-.079.081C9.843,25.464,8.934,25.475,8.038,25.475Zm17.548-9.317-.333,0-.694-.009-.694-.009h-.113l-1.233-.015-.043-.044-.021-.022-.033-.034c-.107-2.108-.129-4.251-.065-6.369a.7.7,0,0,0,.163-.2c.466,0,.932,0,1.385,0,1.373,0,2.768.013,4.148.038l.051.052.112.115c.043,2.069.043,4.166,0,6.235a.639.639,0,0,1-.1.168C27.282,16.124,26.43,16.159,25.586,16.159Zm-17.248,0-.333,0-.6-.007-.648-.008-.138,0h-.1l-1.25-.015-.1-.1c-.107-2.107-.129-4.25-.065-6.369a.7.7,0,0,0,.163-.2c.466,0,.932,0,1.385,0,1.373,0,2.768.013,4.148.038l.163.168c.043,2.069.043,4.166,0,6.235a.638.638,0,0,1-.1.168C10.034,16.124,9.183,16.159,8.338,16.159Zm8.323,0c-.907,0-1.827-.011-2.734-.034l-.138-.142-.01-.01-.08-.083c-.043-2.047-.043-4.122,0-6.168a1.126,1.126,0,0,1,.163-.268c.471,0,.942,0,1.4,0,1.389,0,2.8.013,4.2.038l.014.014.035.036.049.05c.107,2.063.129,4.161.065,6.235a.774.774,0,0,1-.228.3C18.489,16.146,17.569,16.157,16.662,16.157Z"
                        transform="translate(0 0)"
                        // fill="#22e1fe"
                        opacity="0.996"
                      />
                    </svg>
                  </span>
                </Link>
              </li> */}
            </ul>
          </div>
        </>
      ) : (
        <>
          <div className={menuD || menu ? "navigation active" : "navigation"}>
            <ul>
              <li className="logo">
                <Link to="./Dashboard">
                  <span className="icon icon__logo purple">
                    {/* <img src={Logo} width="40px" alt="" /> */}
                  </span>
                </Link>
              </li>
              <li className={isActiveDash ? "nav__list  active" : "nav__list"}>
                <Link to="/Dashboard" title="Dashboard">
                  <span className="icon icon_nav icon__dashboard">
                    <svg
                      id="Layer_2"
                      data-name="Layer 2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 34 34"
                    >
                      <g id="Layer_1" data-name="Layer 1">
                        <path
                          id="Path_11558"
                          data-name="Path 11558"
                          d="M0,17.465v-.93A4.717,4.717,0,0,1,1.532,14.16q6.319-6.286,12.605-12.6A4.745,4.745,0,0,1,16.535,0h.93a4.692,4.692,0,0,1,2.373,1.532q6.309,6.339,12.649,12.647A4.528,4.528,0,0,1,34,16.6v.8a.954.954,0,0,0-.057.151,3.1,3.1,0,0,1-3.091,2.576h-.5v.448c0,3.285.009,6.569-.008,9.854a3.62,3.62,0,0,1-2.553,3.4c-.209.066-.421.116-.632.173H21.051a1.178,1.178,0,0,1-.793-1.266c.016-2.531.009-5.063.006-7.594a1.678,1.678,0,0,0-1.822-1.814c-.94,0-1.879,0-2.819,0A1.692,1.692,0,0,0,13.733,25.2c0,2.509-.009,5.019.006,7.528A1.178,1.178,0,0,1,12.949,34H6.84a.282.282,0,0,0-.084-.047,3.717,3.717,0,0,1-3.121-3.824c.044-3.2.011-6.394.011-9.592v-.413c-.232,0-.418.009-.6,0a3.05,3.05,0,0,1-2.693-1.7A7.144,7.144,0,0,1,0,17.465Z"
                        />
                      </g>
                    </svg>
                  </span>
                </Link>
              </li>
              {roleid === "1" || roleid === "2" || roleid === "3" ? (
                <>
                  {roleid === "1" ? (
                    <>
                      <li
                        className={
                          isActiveOrg ? "nav__list  active" : "nav__list"
                        }
                      >
                        <Link
                          to="/ManageOrganisation"
                          title="Manage Organisation"
                        >
                          <span className="icon icon_nav icon__mng-course">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="30"
                              height="32.65"
                              viewBox="0 0 33.633 37.767"
                            >
                              <g
                                id="clerk-with-tie"
                                transform="translate(-28.099 511.808)"
                              >
                                <path
                                  id="Path_11986"
                                  data-name="Path 11986"
                                  d="M139.355-511.778a7.151,7.151,0,0,0-3.011,1.166,7.168,7.168,0,0,0-1.542,1.564c-.177.273-.221.3-.694.391a3.432,3.432,0,0,0-2.715,2.324,4.476,4.476,0,0,0-.007,3.734,1.569,1.569,0,0,1,.184.782c0,.391-.015.428-.325.73a3.525,3.525,0,0,0-.539.708c-.192.376-.207.45-.207,1.321a3.987,3.987,0,0,0,.177,1.476,3.447,3.447,0,0,0,2.221,2.561l.406.125.443.8c1.092,1.992,1.963,3,3.077,3.549a5.5,5.5,0,0,0,2.937.657,5.5,5.5,0,0,0,2.937-.657c1.114-.546,1.985-1.557,3.077-3.549l.443-.8.406-.125a3.447,3.447,0,0,0,2.221-2.561,3.987,3.987,0,0,0,.177-1.476c0-.871-.015-.945-.207-1.321a3.328,3.328,0,0,0-.539-.708l-.325-.325-.044-1.424c-.081-3.107-.369-4.486-1.232-5.866a7.778,7.778,0,0,0-4.479-2.87A10.6,10.6,0,0,0,139.355-511.778Z"
                                  transform="translate(-94.845 0)"
                                />
                                <path
                                  id="Path_11987"
                                  data-name="Path 11987"
                                  d="M39.566-212.271c-.317.074-7.563,2.988-8.109,3.261a6.075,6.075,0,0,0-3.2,3.97,26.368,26.368,0,0,0-.14,4.036c-.03,3.261-.022,3.66.089,3.889.251.531-1.166.487,16.713.487s16.462.044,16.713-.487c.111-.229.118-.627.089-3.889a26.371,26.371,0,0,0-.14-4.036,6.075,6.075,0,0,0-3.2-3.97c-.539-.273-7.792-3.188-8.109-3.261a.84.84,0,0,0-.871.317c-.1.125-.583,1.372-1.085,2.767s-.93,2.546-.959,2.56-.125-.192-.221-.465l-.17-.494.3-.716c.391-.945.421-1.1.266-1.424-.221-.465-.3-.48-2.612-.48s-2.391.015-2.612.48c-.155.325-.125.48.266,1.424l.3.716-.17.5c-.1.273-.2.472-.229.443s-.472-1.2-.974-2.6a25.728,25.728,0,0,0-1.092-2.752A.858.858,0,0,0,39.566-212.271Zm17.075,8.582a1.114,1.114,0,0,1,.332.3c.148.2.155.3.155,1.815,0,1.424-.015,1.623-.133,1.808-.273.413-.362.421-3.726.4-3.328-.022-3.261-.015-3.512-.435a12.329,12.329,0,0,1-.007-3.534c.229-.435.221-.435,3.616-.435A19.226,19.226,0,0,1,56.641-203.689Z"
                                  transform="translate(0 -277.415)"
                                />
                              </g>
                            </svg>
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          isActiveAdmin ? "nav__list  active" : "nav__list"
                        }
                      >
                        <Link to="/SystemManagers" title="System Managers">
                          <span className="icon icon_nav icon__my-courses">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="30"
                              height="30"
                              viewBox="0 0 29.869 29.869"
                            >
                              <g
                                id="user_1_"
                                data-name="user (1)"
                                transform="translate(0.5 0.5)"
                              >
                                <g
                                  id="Group_11122"
                                  data-name="Group 11122"
                                  transform="translate(4.528 -0.5)"
                                >
                                  <path
                                    id="Path_12694"
                                    data-name="Path 12694"
                                    d="M90.921-.5h1.75a6.181,6.181,0,0,1,2.392,11.347,6.334,6.334,0,0,1-5.309.583A6.114,6.114,0,0,1,85.7,4.867,6.159,6.159,0,0,1,90.921-.5Z"
                                    transform="translate(-85.681 0.5)"
                                    fillRule="evenodd"
                                    opacity="0.989"
                                  />
                                </g>
                                <g
                                  id="Group_11123"
                                  data-name="Group 11123"
                                  transform="translate(14.094 13.266)"
                                >
                                  <path
                                    id="Path_12695"
                                    data-name="Path 12695"
                                    d="M264.938,240.546v.7a1.251,1.251,0,0,1-.35.438,13.471,13.471,0,0,0-1.2.9l-.029.263a9.392,9.392,0,0,1,.029,1.6,13.471,13.471,0,0,0,1.2.9,1.251,1.251,0,0,1,.35.438v.7q-.589.972-1.138,1.983a1.015,1.015,0,0,1-1.138.438l-1.488-.613q-.4.236-.788.5a4.331,4.331,0,0,1-.875.379q-.073.878-.2,1.75a1.4,1.4,0,0,1-.613.642h-2.8a1.159,1.159,0,0,1-.554-.583q-.131-.894-.262-1.779a9.226,9.226,0,0,1-1.6-.9l-1.488.613a1.038,1.038,0,0,1-1.079-.321q-.606-1.007-1.167-2.042a1.038,1.038,0,0,1,.117-.992,16.563,16.563,0,0,1,1.313-1.021.255.255,0,0,0,.117-.233,9.2,9.2,0,0,1-.029-1.721q-.755-.55-1.458-1.167a1.12,1.12,0,0,1,.058-1.167l1.108-1.867a1.063,1.063,0,0,1,1.021-.263,8.748,8.748,0,0,0,1.575.583,8.729,8.729,0,0,1,1.546-.9q.091-.879.233-1.75a.928.928,0,0,1,.438-.5,18.871,18.871,0,0,1,2.917-.058,1.178,1.178,0,0,1,.613.613q.1.88.263,1.75a8.011,8.011,0,0,1,1.6.875l1.488-.613a1.054,1.054,0,0,1,1.138.438Q264.349,239.574,264.938,240.546Zm-8.109.758a2.257,2.257,0,1,1-1.721,2.625A2.339,2.339,0,0,1,256.829,241.3Z"
                                    transform="translate(-249.663 -235.468)"
                                    fillRule="evenodd"
                                    opacity="0.984"
                                  />
                                </g>
                                <g
                                  id="Group_11124"
                                  data-name="Group 11124"
                                  transform="translate(-0.5 13.387)"
                                >
                                  <path
                                    id="Path_12696"
                                    data-name="Path 12696"
                                    d="M18.285,253.518H.667A1.836,1.836,0,0,1-.5,252.41v-4.842a11.188,11.188,0,0,1,15.81-9.013A3.378,3.378,0,0,0,14,239.575q-.5.919-1.05,1.808a2.687,2.687,0,0,0,1.079,3.85.5.5,0,0,1,0,.467,2.687,2.687,0,0,0-1.079,3.85q.472.736.875,1.517a2.561,2.561,0,0,0,3,1.313A9.7,9.7,0,0,0,17.76,252a2.985,2.985,0,0,1,.321.233A8.822,8.822,0,0,0,18.285,253.518Z"
                                    transform="translate(0.5 -237.535)"
                                    fillRule="evenodd"
                                    opacity="0.992"
                                  />
                                </g>
                              </g>
                            </svg>
                          </span>
                        </Link>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}
                  <li
                    className={
                      isActiveLearner ? "nav__list active" : "nav__list"
                    }
                  >
                    <Link to="/AllLearners" title="All Learners">
                      <span className="icon icon_nav icon__lern-path">
                        <svg
                          id="Group_10768"
                          data-name="Group 10768"
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="36.19"
                          viewBox="0 0 34.454 41.017"
                        >
                          <defs>
                            <clipPath id="clipPath">
                              <rect
                                id="Rectangle_179"
                                data-name="Rectangle 179"
                                width="34.454"
                                height="41.017"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Group_10841"
                            data-name="Group 10841"
                            clipPath="url(#clip-path)"
                          >
                            <path
                              id="Path_11720"
                              data-name="Path 11720"
                              d="M104.912,0a17.647,17.647,0,0,1,1.764.483A6.8,6.8,0,1,1,103.244.07a1.453,1.453,0,0,0,.225-.07Z"
                              transform="translate(-86.967)"
                            />
                            <path
                              id="Path_11721"
                              data-name="Path 11721"
                              d="M42.68,195.926c-1.035-.386-2.044-.761-3.052-1.139l-8.686-3.258a1.308,1.308,0,0,1-1.065-1.517c0-.732,0-1.465,0-2.224.3-.018.579-.014.85-.055a3.453,3.453,0,0,0,3.094-3.093,21.157,21.157,0,0,0,0-4.158,3.493,3.493,0,0,0-3.6-3.136c-.093,0-.186,0-.343,0v-1.194c0-.454,0-.908,0-1.362a1.208,1.208,0,0,1,1.745-1.2q3.243,1.206,6.48,2.426c1.423.534,2.844,1.073,4.27,1.6a.41.41,0,0,1,.333.448q-.014,8.774-.008,17.549c0,.09-.01.181-.018.312"
                              transform="translate(-26.678 -154.909)"
                            />
                            <path
                              id="Path_11722"
                              data-name="Path 11722"
                              d="M184.865,187.819c0,.919.033,1.8-.011,2.675-.03.591-.469.886-.992,1.08q-3.018,1.119-6.029,2.255l-5.242,1.964c-.16.06-.323.114-.517.183-.008-.145-.02-.259-.02-.372q0-8.715-.007-17.429a.459.459,0,0,1,.356-.515q5.324-1.978,10.639-3.979a1.227,1.227,0,0,1,1.833,1.272q0,1.162,0,2.324a.281.281,0,0,1-.02.072,11.877,11.877,0,0,0-1.291.189,3.458,3.458,0,0,0-2.657,3.1,27.307,27.307,0,0,0,.005,3.963,3.541,3.541,0,0,0,3.544,3.214c.12,0,.24,0,.415,0"
                              transform="translate(-153.627 -154.964)"
                            />
                            <path
                              id="Path_11723"
                              data-name="Path 11723"
                              d="M73.643,139.032a13.5,13.5,0,0,1,4.179-2.573.548.548,0,0,1,.4.073,9.1,9.1,0,0,0,9.512.012.632.632,0,0,1,.471-.062,13.356,13.356,0,0,1,4.005,2.449.85.85,0,0,1,.091.131l-2.211.829c-2.244.843-4.487,1.692-6.737,2.52a1.064,1.064,0,0,1-.679.014c-2.9-1.07-5.79-2.16-8.683-3.246-.1-.037-.195-.082-.346-.146"
                              transform="translate(-65.759 -121.836)"
                            />
                            <path
                              id="Path_11724"
                              data-name="Path 11724"
                              d="M4.8,234.834c0,.507.006,1.015,0,1.522a1.207,1.207,0,0,1-1.262,1.259,4.043,4.043,0,0,1-2-.3,2.8,2.8,0,0,1,1.159-5.3c.307-.01.615-.013.921,0A1.193,1.193,0,0,1,4.8,233.191c.016.547,0,1.1,0,1.643"
                              transform="translate(0 -207.164)"
                            />
                            <path
                              id="Path_11725"
                              data-name="Path 11725"
                              d="M276.883,234.849c0-.508-.006-1.015,0-1.522a1.193,1.193,0,0,1,1.234-1.243,7.09,7.09,0,0,1,1.354.074,2.771,2.771,0,0,1,2.21,2.96,2.814,2.814,0,0,1-2.672,2.565c-.293.012-.588.01-.881,0a1.2,1.2,0,0,1-1.244-1.235c-.009-.534,0-1.068,0-1.6"
                              transform="translate(-247.238 -207.236)"
                            />
                          </g>
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li
                    className={
                      isActiveCourses ? "nav__list active" : "nav__list"
                    }
                  >
                    <Link to="/ManageCourses" title="Manage Courses">
                      <span className="icon icon_nav icon__lern-path">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28.05"
                          height="26.757"
                          viewBox="0 0 28.05 26.757"
                        >
                          <g
                            id="online-course"
                            transform="translate(-11.176 488.877)"
                          >
                            <path
                              id="Path_12961"
                              data-name="Path 12961"
                              d="M12.9-488.826a2.073,2.073,0,0,0-1.571,1.25l-.132.327-.017,7.934c-.006,5.222.006,8.043.046,8.249a1.978,1.978,0,0,0,1.043,1.45l.361.195,4.781.017,4.781.011-.04.573a5.12,5.12,0,0,1-1.043,3.2c-.487.527-.694.6-1.943.636-.906.029-1.061.046-1.261.155a1.471,1.471,0,0,0-.774,1.5c0,.654.115.917.487,1.095.235.115.327.115,7.7.1,7.429-.017,7.458-.017,7.613-.138.321-.241.4-.4.418-.923a1.559,1.559,0,0,0-.722-1.605c-.269-.155-.31-.161-1.307-.189-.957-.034-1.055-.046-1.359-.183a2.27,2.27,0,0,1-1.072-1.158,7.106,7.106,0,0,1-.579-2.74v-.332l4.747-.011,4.741-.017.327-.155a2.053,2.053,0,0,0,.957-.963l.149-.315v-16.567l-.195-.361a1.974,1.974,0,0,0-1.508-1.049C37.088-488.9,13.333-488.89,12.9-488.826Zm24.4,8.925.011,7.011H13.115v-6.982c0-3.841.017-7.005.04-7.022s5.457-.034,12.078-.029l12.044.017Zm-9.562,10.846a10.041,10.041,0,0,0,.315,2.15,4.557,4.557,0,0,0,.8,1.6l.264.327H21.3l.292-.321a5.887,5.887,0,0,0,1.129-3.52l.04-.573h4.97Z"
                              transform="translate(0 0)"
                            />
                            <path
                              id="Path_12962"
                              data-name="Path 12962"
                              d="M117.2-425.867c-.109.023-1.943.705-4.07,1.513a33.533,33.533,0,0,0-4,1.617.55.55,0,0,0-.132.418c0,.367.149.522.705.728l.441.166v2.809l-.166.1c-.344.189-.378.35-.378,1.657,0,1.29.029,1.422.327,1.576a1.586,1.586,0,0,0,.568.08c.384,0,.418-.011.6-.195l.195-.195v-1.215c0-1.364-.034-1.508-.378-1.725l-.195-.12v-1.255c0-.969.017-1.255.075-1.255a5.176,5.176,0,0,1,.527.189l.459.183.029,1.863a6.621,6.621,0,0,0,.126,2.047,5.2,5.2,0,0,0,2.568,1.25,11.858,11.858,0,0,0,3.29.3,9.512,9.512,0,0,0,4.133-.837c.636-.3.98-.568,1.095-.848A9.085,9.085,0,0,0,123.1-419v-1.794l1.221-.459c1.37-.516,1.588-.654,1.588-1.026a.656.656,0,0,0-.355-.625c-.1-.046-1.863-.722-3.9-1.5a37.057,37.057,0,0,0-4.225-1.519C117.41-425.913,117.306-425.89,117.2-425.867Zm4.317,2.029c2.356.894,3.795,1.473,3.795,1.519,0,.1-7.6,2.987-7.854,2.987-.149,0-3.268-1.141-5.389-1.972l-.338-.138.281-.034c.161-.017,1.45-.149,2.866-.292s2.637-.287,2.711-.315a.213.213,0,0,0,.126-.224c0-.338.12-.338-3.7.046l-3.525.361-.441-.172c-.258-.1-.447-.2-.447-.246s1.33-.585,3.806-1.525c2.092-.8,3.858-1.45,3.927-1.462a.75.75,0,0,1,.252.006C117.656-425.288,119.427-424.629,121.514-423.838Zm-10.92,5.8c.12.086.126.115.126,1.175v1.089l-.269-.017-.275-.017v-1.078c0-1,.006-1.089.109-1.164C110.427-418.151,110.439-418.146,110.594-418.037Z"
                              transform="translate(-92.216 -59.348)"
                            />
                          </g>
                        </svg>
                      </span>
                    </Link>
                  </li>
                  {roleid === "2" ? (
                    <>
                      <li
                        className={
                          isActiveCalendar ? "nav__list  active" : "nav__list"
                        }
                      >
                        <Link to="/Calendar" title="Calendar">
                          <span className="icon icon_nav icon__mng-course">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="32.109"
                              height="30.015"
                              viewBox="0 0 32.109 30.015"
                            >
                              <g id="calendar" transform="translate(-15 482)">
                                <path
                                  id="Path_13435"
                                  data-name="Path 13435"
                                  d="M16.988-481.907a2.693,2.693,0,0,0-1.622,1.369c-.312.618-.366,1.05-.366,3.2v1.981H47.05l-.02-2.114-.02-2.107-.213-.452a3.711,3.711,0,0,0-2.473-1.881A13.185,13.185,0,0,0,42.276-482H40.661v1.509a15.387,15.387,0,0,1-.066,1.748,1.178,1.178,0,0,1-.3.465.77.77,0,0,1-.578.253.707.707,0,0,1-.578-.133c-.505-.346-.505-.339-.525-2.187L38.587-482H22.645v1.443c-.007,1.735-.04,1.955-.352,2.26a1,1,0,0,1-1.529-.173c-.14-.226-.146-.319-.166-1.888L20.578-482l-1.642.007A12.225,12.225,0,0,0,16.988-481.907Z"
                                  transform="translate(0)"
                                />
                                <path
                                  id="Path_13436"
                                  data-name="Path 13436"
                                  d="M15.013-341.447l.02,9.56.173.439a2.569,2.569,0,0,0,1.615,1.635c.319.113,1.024.12,13.934.12H44.35l.445-.153a3.661,3.661,0,0,0,2.068-1.742l.213-.432.02-9.487L47.109-351H15Zm9.354-5.744a1,1,0,0,1,.3.266c.126.173.14.293.16,1.542s.013,1.383-.106,1.655c-.233.525-.293.539-1.981.539-2.094,0-2.021.08-2.021-2.048s-.086-2.034,2.028-2.034A6.516,6.516,0,0,1,24.367-347.191Zm7.911,0a1,1,0,0,1,.3.266c.126.173.14.293.16,1.562.027,1.529-.02,1.795-.339,2.034-.179.133-.273.14-1.709.14-2.141,0-2.061.086-2.061-2.048s-.086-2.034,2.028-2.034A6.516,6.516,0,0,1,32.278-347.191Zm8.051.013c.366.193.4.346.4,1.961,0,2.134.106,2.028-2.054,2.028-1.463,0-1.509-.007-1.715-.153-.306-.219-.352-.465-.352-1.928,0-1.4.04-1.609.366-1.861.179-.14.246-.146,1.675-.146A5.275,5.275,0,0,1,40.329-347.178Zm-15.842,9.061c.306.219.352.465.352,1.895,0,1.356-.04,1.542-.359,1.841-.179.166-.186.166-1.675.186-1.416.02-1.509.013-1.715-.12-.359-.219-.379-.346-.359-2.014.02-1.482.02-1.5.179-1.669a1.022,1.022,0,0,1,.366-.239,13.223,13.223,0,0,1,1.6-.047C24.214-338.269,24.28-338.263,24.487-338.116Zm7.871-.033c.332.226.359.352.359,1.9a14.128,14.128,0,0,1-.053,1.622.65.65,0,0,1-.266.313c-.193.12-.339.133-1.7.133-2.181,0-2.087.093-2.061-2.127.02-1.509.02-1.522.179-1.689a1.022,1.022,0,0,1,.366-.239,13.223,13.223,0,0,1,1.6-.047C32-338.269,32.2-338.256,32.358-338.15Zm7.778-.086a1.161,1.161,0,0,1,.4.239l.16.173v3.244l-.186.179-.179.186H37.084l-.173-.16c-.279-.266-.319-.525-.293-2.014.027-1.941-.007-1.908,2.014-1.908A11.141,11.141,0,0,1,40.136-338.236Z"
                                  transform="translate(0 -122.291)"
                                />
                              </g>
                            </svg>
                          </span>
                        </Link>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}
                  <li
                    className={
                      isActiveReports ? "nav__list  active" : "nav__list"
                    }
                  >
                    <Link to="/Reports" title="Reports">
                      <span className="icon icon_nav icon__my-courses">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32.102"
                          height="21.38"
                          viewBox="0 0 32.102 21.38"
                        >
                          <g
                            id="Group_11426"
                            data-name="Group 11426"
                            transform="translate(0)"
                          >
                            <path
                              id="Path_13250"
                              data-name="Path 13250"
                              d="M7.1-340.868a.9.9,0,0,1,.364.37c.125.245.125.351.125,9.624v9.374H9.468v-6.239c0-6.132,0-6.245.125-6.489a.84.84,0,0,1,.376-.376c.232-.119.364-.125,2.32-.125s2.088.006,2.32.125a.84.84,0,0,1,.376.376c.125.245.125.357.125,6.489v6.239h1.881v-4.514c0-4.408.006-4.527.125-4.765a.84.84,0,0,1,.376-.376c.232-.119.364-.125,2.32-.125s2.088.006,2.32.125a.84.84,0,0,1,.376.376c.119.238.125.357.125,4.765v4.514h1.881v-3.386c0-3.273.006-3.4.125-3.637a.84.84,0,0,1,.376-.376c.232-.119.364-.125,2.32-.125s2.088.006,2.32.125a.84.84,0,0,1,.376.376c.119.238.125.364.125,3.637v3.386h.6a1.672,1.672,0,0,1,.846.125.99.99,0,0,1,.5.815.99.99,0,0,1-.5.815c-.245.125-.332.125-15.549.125s-15.3,0-15.549-.125a.99.99,0,0,1-.5-.815.99.99,0,0,1,.5-.815,1.672,1.672,0,0,1,.846-.125h.6v-9.374c0-9.273,0-9.38.125-9.624a.84.84,0,0,1,.376-.376c.232-.119.364-.125,2.332-.125S6.878-340.987,7.1-340.868Z"
                              transform="translate(0 341)"
                            />
                          </g>
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname.includes("/HelpNSupport")
                        ? "nav__list  active"
                        : "nav__list"
                    }
                  >
                    <Link to="/HelpNSupport" title="Help & Support">
                      <span className="icon icon_nav icon__reports">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="38.86"
                          viewBox="0 0 28.789 37.291"
                        >
                          <g
                            id="Group_10749"
                            data-name="Group 10749"
                            transform="translate(-406.378 -367.315)"
                          >
                            <path
                              id="Path_11654"
                              data-name="Path 11654"
                              d="M424.587,420.136a.567.567,0,0,1,.02.143,1.893,1.893,0,0,0,1.244,2.2c.62.293,1.256.555,1.892.812a21.084,21.084,0,0,1,5.3,2.827,4.766,4.766,0,0,1,2.033,2.92,8.89,8.89,0,0,1,.032,2.366,2.8,2.8,0,0,1-1.355,1.931,9.919,9.919,0,0,1-3.786,1.447,42.082,42.082,0,0,1-8.334.671,56.6,56.6,0,0,1-7.918-.345,15.992,15.992,0,0,1-4.676-1.213,4.066,4.066,0,0,1-2.471-2.515,4.262,4.262,0,0,1,1-4.21,11.2,11.2,0,0,1,3.178-2.341c1.535-.809,3.111-1.54,4.669-2.306a7.5,7.5,0,0,0,.859-.446,1.8,1.8,0,0,0,.634-2.447,8.161,8.161,0,0,0-.777-1.13,13.707,13.707,0,0,1-2.886-6.461,10.179,10.179,0,0,1,.684-5.98,6.989,6.989,0,0,1,5.776-4.074,8.341,8.341,0,0,1,4.595.591,7.1,7.1,0,0,1,4.118,5.54,12.1,12.1,0,0,1-1.078,7.439.661.661,0,0,1-.37.309,7.624,7.624,0,0,1-1.1.242,1.2,1.2,0,0,1-.45-.078,10.119,10.119,0,0,0-1.309-.341,10,10,0,0,0-1.5-.008,2.229,2.229,0,0,0,.007,4.457C423.259,420.149,423.907,420.136,424.587,420.136Z"
                              transform="translate(0 -30.844)"
                            />
                            <path
                              id="Path_11655"
                              data-name="Path 11655"
                              d="M420.777,382.235c0-.634-.006-1.268,0-1.9a2,2,0,0,1,.886-1.684.628.628,0,0,0,.233-.411,11.775,11.775,0,0,1,23.393-.875c.012.08.016.161.021.242a1.486,1.486,0,0,0,.614,1.331,1.567,1.567,0,0,1,.582,1.366c.008,1.282.019,2.564,0,3.845a1.993,1.993,0,0,1-2.818,1.805.578.578,0,0,0-.458,0,11,11,0,0,1-4.86,1.633,1.654,1.654,0,0,0-.436.219,3.512,3.512,0,0,1-.924.408,9.222,9.222,0,0,1-1.5.016,1.144,1.144,0,0,1-1.167-1.1,1.117,1.117,0,0,1,1.055-1.205,14.389,14.389,0,0,1,1.738,0,.85.85,0,0,1,.553.208.918.918,0,0,0,.942.245,9.851,9.851,0,0,0,3.721-1.276.413.413,0,0,0,.226-.512,8.388,8.388,0,0,1-.051-1.331c-.005-.958,0-1.916,0-2.874a1.982,1.982,0,0,1,.879-1.725.515.515,0,0,0,.171-.389A9.971,9.971,0,0,0,423.888,377c-.044.2-.075.4-.114.6-.1.522-.153.98.42,1.346a1.472,1.472,0,0,1,.559,1.291c0,1.322.018,2.645,0,3.967a1.921,1.921,0,0,1-1.95,1.912,1.95,1.95,0,0,1-2.017-1.9c-.023-.66,0-1.322,0-1.983Z"
                              transform="translate(-12.84)"
                            />
                          </g>
                        </svg>
                      </span>
                    </Link>
                  </li>
                </>
              ) : roleid === "4" ? (
                <>
                  <li
                    className={
                      isActiveCatalog ? "nav__list active" : "nav__list"
                    }
                  >
                    <Link to="/Catalog" title="Course Catalog">
                      <span className="icon icon_nav icon__lern-path course-catalog-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="35"
                          viewBox="0 0 34.454 41.017"
                        >
                          <defs>
                            <clipPath id="clipPath">
                              <rect
                                id="Rectangle_179"
                                data-name="Rectangle 179"
                                width="34.454"
                                height="41.017"
                              />
                            </clipPath>
                          </defs>
                          <path
                            id="Exclusion_6"
                            data-name="Exclusion 6"
                            d="M16.662,31.241c-5.075,0-10.221-.011-15.3-.034a1.984,1.984,0,0,1-.872-.5A2,2,0,0,1,0,29.833V1.408A2,2,0,0,1,.494.53a1.983,1.983,0,0,1,.872-.5C6.441.011,11.586,0,16.662,0s10.222.011,15.3.034a1.983,1.983,0,0,1,.872.5,2,2,0,0,1,.494.878V29.833a1.883,1.883,0,0,1-1.367,1.374C26.882,31.23,21.736,31.241,16.662,31.241ZM9.76,6.365c-2.29,0-4.61,0-6.9,0a1.3,1.3,0,0,1-.228.268c-.043,7.161-.043,14.424,0,21.587l.033.041,0,0,.072.089.055.068c5.354.045,10.785.068,16.142.068,3.823,0,7.7-.012,11.519-.035a.587.587,0,0,0,.228-.235c.043-7.161.043-14.424,0-21.587L30.652,6.6l-.082-.085-.037-.038L30.46,6.4C23.6,6.377,16.637,6.365,9.76,6.365Zm-1.3-4.219h0a1.739,1.739,0,0,0-1.053.962,1.846,1.846,0,0,0,.24,1.451,1.667,1.667,0,0,0,1.107.531,1.585,1.585,0,0,0,1.171-.665A1.882,1.882,0,0,0,9.919,2.81a1.792,1.792,0,0,0-1.458-.664Zm-3.747.064-.158,0a1.515,1.515,0,0,0-.748,2.212A1.691,1.691,0,0,0,5,5.089a1.639,1.639,0,0,0,1.213-.732A1.908,1.908,0,0,0,6.11,2.724,1.644,1.644,0,0,0,4.714,2.209Zm7.485,0-.158,0a1.515,1.515,0,0,0-.748,2.212,1.689,1.689,0,0,0,1.193.66A1.646,1.646,0,0,0,13.7,4.358a1.908,1.908,0,0,0-.105-1.634A1.644,1.644,0,0,0,12.2,2.209Zm9.249,0c-.781,0-1.581,0-2.378,0a2.2,2.2,0,0,0-.879.6,1.714,1.714,0,0,0-.141,1.308A1.635,1.635,0,0,0,19,4.995c1.587.022,3.2.034,4.784.034s3.2-.011,4.784-.034a1.4,1.4,0,0,0,1.009-.7,1.671,1.671,0,0,0,.021-1.3,1.583,1.583,0,0,0-1.03-.747C26.208,2.221,23.811,2.208,21.448,2.208Zm3.243,23.271c-.679,0-1.367-.012-2.045-.037a.457.457,0,0,1-.228-.168c-.107-2.085-.129-4.205-.065-6.3a1.306,1.306,0,0,0,.228-.268c.46,0,.92,0,1.368,0,1.357,0,2.736.013,4.1.038l.076.078.019.02.089.091.044.046c.043,2.047.043,4.122,0,6.168a.469.469,0,0,1-.163.235C26.981,25.444,25.829,25.479,24.691,25.479Zm-8.653,0c-.679,0-1.367-.012-2.045-.037a.457.457,0,0,1-.228-.168c-.107-2.085-.129-4.206-.065-6.3a1.3,1.3,0,0,0,.228-.268c.46,0,.921,0,1.368,0,1.357,0,2.736.013,4.1.038l.228.235c.043,2.047.043,4.122,0,6.168a.469.469,0,0,1-.163.235C18.328,25.444,17.176,25.479,16.038,25.479Zm-8,0c-.9,0-1.805-.011-2.7-.034l-.03-.026L5.3,25.409l-.025-.022-.132-.113c-.075-2.112-.086-4.254-.033-6.369a2,2,0,0,1,.228-.2c.454,0,.909,0,1.352,0,1.34,0,2.7.013,4.05.038a.616.616,0,0,1,.163.1c.107,2.108.129,4.251.065,6.369l-.05.051-.013.014-.086.089-.079.081C9.843,25.464,8.934,25.475,8.038,25.475Zm17.548-9.317-.333,0-.694-.009-.694-.009h-.113l-1.233-.015-.043-.044-.021-.022-.033-.034c-.107-2.108-.129-4.251-.065-6.369a.7.7,0,0,0,.163-.2c.466,0,.932,0,1.385,0,1.373,0,2.768.013,4.148.038l.051.052.112.115c.043,2.069.043,4.166,0,6.235a.639.639,0,0,1-.1.168C27.282,16.124,26.43,16.159,25.586,16.159Zm-17.248,0-.333,0-.6-.007-.648-.008-.138,0h-.1l-1.25-.015-.1-.1c-.107-2.107-.129-4.25-.065-6.369a.7.7,0,0,0,.163-.2c.466,0,.932,0,1.385,0,1.373,0,2.768.013,4.148.038l.163.168c.043,2.069.043,4.166,0,6.235a.638.638,0,0,1-.1.168C10.034,16.124,9.183,16.159,8.338,16.159Zm8.323,0c-.907,0-1.827-.011-2.734-.034l-.138-.142-.01-.01-.08-.083c-.043-2.047-.043-4.122,0-6.168a1.126,1.126,0,0,1,.163-.268c.471,0,.942,0,1.4,0,1.389,0,2.8.013,4.2.038l.014.014.035.036.049.05c.107,2.063.129,4.161.065,6.235a.774.774,0,0,1-.228.3C18.489,16.146,17.569,16.157,16.662,16.157Z"
                            transform="translate(0 0)"
                            // fill="#22e1fe"
                            opacity="0.996"
                          />
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li
                    className={isActiveLearn ? "nav__list active" : "nav__list"}
                  >
                    <Link to="/Learn" title="Learn">
                      <span className="icon icon_nav icon__lern-path">
                        <svg
                          id="Group_10768"
                          data-name="Group 10768"
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="35"
                          viewBox="0 0 34.454 41.017"
                        >
                          <defs>
                            <clipPath id="clipPath">
                              <rect
                                id="Rectangle_179"
                                data-name="Rectangle 179"
                                width="34.454"
                                height="41.017"
                              />
                            </clipPath>
                          </defs>
                          <g
                            id="Group_10841"
                            data-name="Group 10841"
                            clipPath="url(#clip-path)"
                          >
                            <path
                              id="Path_11720"
                              data-name="Path 11720"
                              d="M104.912,0a17.647,17.647,0,0,1,1.764.483A6.8,6.8,0,1,1,103.244.07a1.453,1.453,0,0,0,.225-.07Z"
                              transform="translate(-86.967)"
                            />
                            <path
                              id="Path_11721"
                              data-name="Path 11721"
                              d="M42.68,195.926c-1.035-.386-2.044-.761-3.052-1.139l-8.686-3.258a1.308,1.308,0,0,1-1.065-1.517c0-.732,0-1.465,0-2.224.3-.018.579-.014.85-.055a3.453,3.453,0,0,0,3.094-3.093,21.157,21.157,0,0,0,0-4.158,3.493,3.493,0,0,0-3.6-3.136c-.093,0-.186,0-.343,0v-1.194c0-.454,0-.908,0-1.362a1.208,1.208,0,0,1,1.745-1.2q3.243,1.206,6.48,2.426c1.423.534,2.844,1.073,4.27,1.6a.41.41,0,0,1,.333.448q-.014,8.774-.008,17.549c0,.09-.01.181-.018.312"
                              transform="translate(-26.678 -154.909)"
                            />
                            <path
                              id="Path_11722"
                              data-name="Path 11722"
                              d="M184.865,187.819c0,.919.033,1.8-.011,2.675-.03.591-.469.886-.992,1.08q-3.018,1.119-6.029,2.255l-5.242,1.964c-.16.06-.323.114-.517.183-.008-.145-.02-.259-.02-.372q0-8.715-.007-17.429a.459.459,0,0,1,.356-.515q5.324-1.978,10.639-3.979a1.227,1.227,0,0,1,1.833,1.272q0,1.162,0,2.324a.281.281,0,0,1-.02.072,11.877,11.877,0,0,0-1.291.189,3.458,3.458,0,0,0-2.657,3.1,27.307,27.307,0,0,0,.005,3.963,3.541,3.541,0,0,0,3.544,3.214c.12,0,.24,0,.415,0"
                              transform="translate(-153.627 -154.964)"
                            />
                            <path
                              id="Path_11723"
                              data-name="Path 11723"
                              d="M73.643,139.032a13.5,13.5,0,0,1,4.179-2.573.548.548,0,0,1,.4.073,9.1,9.1,0,0,0,9.512.012.632.632,0,0,1,.471-.062,13.356,13.356,0,0,1,4.005,2.449.85.85,0,0,1,.091.131l-2.211.829c-2.244.843-4.487,1.692-6.737,2.52a1.064,1.064,0,0,1-.679.014c-2.9-1.07-5.79-2.16-8.683-3.246-.1-.037-.195-.082-.346-.146"
                              transform="translate(-65.759 -121.836)"
                            />
                            <path
                              id="Path_11724"
                              data-name="Path 11724"
                              d="M4.8,234.834c0,.507.006,1.015,0,1.522a1.207,1.207,0,0,1-1.262,1.259,4.043,4.043,0,0,1-2-.3,2.8,2.8,0,0,1,1.159-5.3c.307-.01.615-.013.921,0A1.193,1.193,0,0,1,4.8,233.191c.016.547,0,1.1,0,1.643"
                              transform="translate(0 -207.164)"
                            />
                            <path
                              id="Path_11725"
                              data-name="Path 11725"
                              d="M276.883,234.849c0-.508-.006-1.015,0-1.522a1.193,1.193,0,0,1,1.234-1.243,7.09,7.09,0,0,1,1.354.074,2.771,2.771,0,0,1,2.21,2.96,2.814,2.814,0,0,1-2.672,2.565c-.293.012-.588.01-.881,0a1.2,1.2,0,0,1-1.244-1.235c-.009-.534,0-1.068,0-1.6"
                              transform="translate(-247.238 -207.236)"
                            />
                          </g>
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li
                    className={isActiveTrack ? "nav__list active" : "nav__list"}
                  >
                    <Link to="/Track" title="Track">
                      <span className="icon icon_nav icon__lern-path">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="35"
                          viewBox="0 0 35.203 37.764"
                        >
                          <g
                            id="Group_11624"
                            data-name="Group 11624"
                            transform="translate(10377.596 14615.575)"
                          >
                            <path
                              id="Subtraction_15"
                              data-name="Subtraction 15"
                              d="M14.978,25.385H.018v-.459c0-1.549,0-3.172,0-4.476V20.33h0C.025,16.169.03,11.868,0,7.62A1.864,1.864,0,0,1,.441,6.248a1.468,1.468,0,0,1,1.085-.39,2.958,2.958,0,0,1,.432.034v18.2H3.276V1.606a2.524,2.524,0,0,1,.091-.73,1.159,1.159,0,0,1,.285-.5,1.159,1.159,0,0,1,.5-.285A2.517,2.517,0,0,1,4.879,0H29.063a1.624,1.624,0,0,1,1.2.378,1.657,1.657,0,0,1,.375,1.213v18.55c-2.01-2.579-4.342-3.887-6.931-3.887a9.289,9.289,0,0,0-3.309.656c-3.593,1.374-5.417,4.225-5.423,8.474Zm-9.716-4.5v1.255h9.07V20.881H5.262Zm7.166-3.256h0v1.256h2.555V17.625Zm-7.169,0h0v1.247h2.57V17.625ZM24.45,11.395c.484,0,.97,0,1.444.015a.553.553,0,0,1,.394.231,1.939,1.939,0,0,0,2.239.993A1.947,1.947,0,0,0,28.5,8.855a1.937,1.937,0,0,0-2.205.987.544.544,0,0,1-.386.243c-.47.009-.954.013-1.441.013s-.987,0-1.49-.013a.5.5,0,0,1-.361-.218,1.969,1.969,0,0,0-3.5,0,.5.5,0,0,1-.36.218c-.386.011-.773.017-1.151.017s-.757-.006-1.128-.017a.55.55,0,0,1-.388-.239A1.92,1.92,0,0,0,14.367,8.8h-.016a1.932,1.932,0,0,0-1.742,1.052.556.556,0,0,1-.393.232c-.481.008-.984.008-1.427.009h-.005c-.427,0-.912,0-1.377.008H9.385a.5.5,0,0,1-.508-.308,1.9,1.9,0,0,0-2.182-.93,1.948,1.948,0,0,0-1.463,1.879h0a1.958,1.958,0,0,0,3.645.979l.017-.03v0l.005-.009c.088-.159.158-.285.4-.285h.016c.486.009.982.009,1.462.009s.978,0,1.468.009a.5.5,0,0,1,.361.218,1.967,1.967,0,0,0,3.5,0,.5.5,0,0,1,.362-.218c.394-.011.786-.016,1.165-.016s.753.006,1.113.016a.543.543,0,0,1,.387.242,1.924,1.924,0,0,0,1.724,1.042h.017a1.934,1.934,0,0,0,1.74-1.054A.543.543,0,0,1,23,11.409C23.48,11.4,23.966,11.395,24.45,11.395ZM10.665,4.881V6.15h4.5V4.881h-4.5Zm-6.208.005h0V6.144h5.809V4.887Zm15.767,0V6.142h9.455V4.888H20.224Zm-4.547,0h0V6.142h3.866V4.888H15.677ZM4.609,1.33V2.6H5.847V1.33Zm5.2.005V2.581H11.08V1.336Zm-2.606,0V2.581h1.27V1.336ZM20.877,11.4h0a.655.655,0,1,1,.6-.408.649.649,0,0,1-.6.408l0,0Zm-6.527,0h0a.655.655,0,1,1,.608-.407.649.649,0,0,1-.608.407l0,0Zm13.681,0a.653.653,0,1,1,.653-.665v0a.653.653,0,0,1-.633.661Zm-20.85,0a.654.654,0,1,1,.011,0Z"
                              transform="translate(-10377.596 -14615.575)"
                            />
                            <path
                              id="Path_14148"
                              data-name="Path 14148"
                              d="M459.719,636.52c1.258,0,2.491,0,3.725.009a.857.857,0,0,1,.392.175c.5.3,1,.6,1.478.926a1.065,1.065,0,0,1,.416.484c.347,1.069.653,2.15.979,3.227.038.126.083.251.132.4h2.79V643H455.35v-1.256h2.79C458.671,640,459.192,638.267,459.719,636.52Z"
                              transform="translate(-10823.126 -15220.815)"
                            />
                            <path
                              id="Subtraction_12"
                              data-name="Subtraction 12"
                              d="M7.168,14.334A7.167,7.167,0,1,1,7.2,0h.01A7,7,0,0,1,9.967.569a7.258,7.258,0,0,1,3.8,3.808,7.014,7.014,0,0,1,.565,2.762,7.2,7.2,0,0,1-4.369,6.628,7.066,7.066,0,0,1-2.784.566ZM7.148,1.3h-.01a5.866,5.866,0,0,0,.051,11.731h.027a5.705,5.705,0,0,0,2.565-.618A5.864,5.864,0,0,0,7.158,1.3h-.01Z"
                              transform="translate(-10361.288 -14597.981)"
                            />
                            <path
                              id="Path_14150"
                              data-name="Path 14150"
                              d="M381.88,598.035H366.828c-1.1,0-1.577-.482-1.578-1.591V594.8h15.094Z"
                              transform="translate(-10742.829 -15183.634)"
                            />
                            <path
                              id="Path_14151"
                              data-name="Path 14151"
                              d="M660.774,422.381H658.83V402.9a1.472,1.472,0,0,1,1.958,1.581c-.035,5.794-.016,11.588-.016,17.382Z"
                              transform="translate(-11004.471 -15012.556)"
                            />
                            <path
                              id="Path_14152"
                              data-name="Path 14152"
                              d="M647.88,597.219c.361-.882.682-1.67,1.018-2.489h2.076c0,.751.057,1.507-.018,2.25a1.194,1.194,0,0,1-1.185.988,8.47,8.47,0,0,1-.894,0,.578.578,0,0,1-.319-.126C648.31,597.631,648.078,597.4,647.88,597.219Z"
                              transform="translate(-10994.713 -15183.571)"
                            />
                            <path
                              id="Path_14153"
                              data-name="Path 14153"
                              d="M649.47,646.409l1-.979a1.331,1.331,0,0,1,.178.126q1.4,1.394,2.791,2.791a1.482,1.482,0,0,1,.136.15.715.715,0,0,1-.048.963.686.686,0,0,1-.99.033C651.512,648.481,650.507,647.45,649.47,646.409Z"
                              transform="translate(-10996.129 -15228.757)"
                            />
                            <path
                              id="Path_14154"
                              data-name="Path 14154"
                              d="M632.867,627.28l1.023,1-1.012.908-.948-.979Z"
                              transform="translate(-10980.498 -15212.58)"
                            />
                            <path
                              id="Path_14166"
                              data-name="Path 14166"
                              d="M426.406,442.462a.653.653,0,1,1-.653-.642A.653.653,0,0,1,426.406,442.462Z"
                              transform="translate(-10796.169 -15047.296)"
                            />
                            <path
                              id="Path_14167"
                              data-name="Path 14167"
                              d="M491.6,443.056a.653.653,0,1,1,.646-.653A.653.653,0,0,1,491.6,443.056Z"
                              transform="translate(-10854.846 -15047.232)"
                            />
                            <path
                              id="Path_14168"
                              data-name="Path 14168"
                              d="M551.563,443.056a.653.653,0,1,1,.642-.653A.653.653,0,0,1,551.563,443.056Z"
                              transform="translate(-10908.282 -15047.234)"
                            />
                            <path
                              id="Path_14169"
                              data-name="Path 14169"
                              d="M618.068,442.453a.653.653,0,1,1-.665-.633A.653.653,0,0,1,618.068,442.453Z"
                              transform="translate(-10966.979 -15047.294)"
                            />
                            <path
                              id="Path_14171"
                              data-name="Path 14171"
                              d="M554.468,546.875v1.254A2.041,2.041,0,0,0,552.5,550.1h-1.221A3.133,3.133,0,0,1,554.468,546.875Z"
                              transform="translate(-10908.604 -15140.922)"
                            />
                          </g>
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li
                    className={
                      isActiveCalendar ? "nav__list  active" : "nav__list"
                    }
                  >
                    <Link to="/Calendar" title="Calendar">
                      <span className="icon icon_nav icon__mng-course">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 32.109 30.015"
                        >
                          <g id="calendar" transform="translate(-15 482)">
                            <path
                              id="Path_13435"
                              data-name="Path 13435"
                              d="M16.988-481.907a2.693,2.693,0,0,0-1.622,1.369c-.312.618-.366,1.05-.366,3.2v1.981H47.05l-.02-2.114-.02-2.107-.213-.452a3.711,3.711,0,0,0-2.473-1.881A13.185,13.185,0,0,0,42.276-482H40.661v1.509a15.387,15.387,0,0,1-.066,1.748,1.178,1.178,0,0,1-.3.465.77.77,0,0,1-.578.253.707.707,0,0,1-.578-.133c-.505-.346-.505-.339-.525-2.187L38.587-482H22.645v1.443c-.007,1.735-.04,1.955-.352,2.26a1,1,0,0,1-1.529-.173c-.14-.226-.146-.319-.166-1.888L20.578-482l-1.642.007A12.225,12.225,0,0,0,16.988-481.907Z"
                              transform="translate(0)"
                            />
                            <path
                              id="Path_13436"
                              data-name="Path 13436"
                              d="M15.013-341.447l.02,9.56.173.439a2.569,2.569,0,0,0,1.615,1.635c.319.113,1.024.12,13.934.12H44.35l.445-.153a3.661,3.661,0,0,0,2.068-1.742l.213-.432.02-9.487L47.109-351H15Zm9.354-5.744a1,1,0,0,1,.3.266c.126.173.14.293.16,1.542s.013,1.383-.106,1.655c-.233.525-.293.539-1.981.539-2.094,0-2.021.08-2.021-2.048s-.086-2.034,2.028-2.034A6.516,6.516,0,0,1,24.367-347.191Zm7.911,0a1,1,0,0,1,.3.266c.126.173.14.293.16,1.562.027,1.529-.02,1.795-.339,2.034-.179.133-.273.14-1.709.14-2.141,0-2.061.086-2.061-2.048s-.086-2.034,2.028-2.034A6.516,6.516,0,0,1,32.278-347.191Zm8.051.013c.366.193.4.346.4,1.961,0,2.134.106,2.028-2.054,2.028-1.463,0-1.509-.007-1.715-.153-.306-.219-.352-.465-.352-1.928,0-1.4.04-1.609.366-1.861.179-.14.246-.146,1.675-.146A5.275,5.275,0,0,1,40.329-347.178Zm-15.842,9.061c.306.219.352.465.352,1.895,0,1.356-.04,1.542-.359,1.841-.179.166-.186.166-1.675.186-1.416.02-1.509.013-1.715-.12-.359-.219-.379-.346-.359-2.014.02-1.482.02-1.5.179-1.669a1.022,1.022,0,0,1,.366-.239,13.223,13.223,0,0,1,1.6-.047C24.214-338.269,24.28-338.263,24.487-338.116Zm7.871-.033c.332.226.359.352.359,1.9a14.128,14.128,0,0,1-.053,1.622.65.65,0,0,1-.266.313c-.193.12-.339.133-1.7.133-2.181,0-2.087.093-2.061-2.127.02-1.509.02-1.522.179-1.689a1.022,1.022,0,0,1,.366-.239,13.223,13.223,0,0,1,1.6-.047C32-338.269,32.2-338.256,32.358-338.15Zm7.778-.086a1.161,1.161,0,0,1,.4.239l.16.173v3.244l-.186.179-.179.186H37.084l-.173-.16c-.279-.266-.319-.525-.293-2.014.027-1.941-.007-1.908,2.014-1.908A11.141,11.141,0,0,1,40.136-338.236Z"
                              transform="translate(0 -122.291)"
                            />
                          </g>
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li
                    className={
                      isActiveHelpSupport ? "nav__list  active" : "nav__list"
                    }
                  >
                    <Link to="/HelpNSupport" title="Help & Support">
                      <span className="icon icon_nav icon__reports">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="38.86"
                          viewBox="0 0 28.789 37.291"
                        >
                          <g
                            id="Group_10749"
                            data-name="Group 10749"
                            transform="translate(-406.378 -367.315)"
                          >
                            <path
                              id="Path_11654"
                              data-name="Path 11654"
                              d="M424.587,420.136a.567.567,0,0,1,.02.143,1.893,1.893,0,0,0,1.244,2.2c.62.293,1.256.555,1.892.812a21.084,21.084,0,0,1,5.3,2.827,4.766,4.766,0,0,1,2.033,2.92,8.89,8.89,0,0,1,.032,2.366,2.8,2.8,0,0,1-1.355,1.931,9.919,9.919,0,0,1-3.786,1.447,42.082,42.082,0,0,1-8.334.671,56.6,56.6,0,0,1-7.918-.345,15.992,15.992,0,0,1-4.676-1.213,4.066,4.066,0,0,1-2.471-2.515,4.262,4.262,0,0,1,1-4.21,11.2,11.2,0,0,1,3.178-2.341c1.535-.809,3.111-1.54,4.669-2.306a7.5,7.5,0,0,0,.859-.446,1.8,1.8,0,0,0,.634-2.447,8.161,8.161,0,0,0-.777-1.13,13.707,13.707,0,0,1-2.886-6.461,10.179,10.179,0,0,1,.684-5.98,6.989,6.989,0,0,1,5.776-4.074,8.341,8.341,0,0,1,4.595.591,7.1,7.1,0,0,1,4.118,5.54,12.1,12.1,0,0,1-1.078,7.439.661.661,0,0,1-.37.309,7.624,7.624,0,0,1-1.1.242,1.2,1.2,0,0,1-.45-.078,10.119,10.119,0,0,0-1.309-.341,10,10,0,0,0-1.5-.008,2.229,2.229,0,0,0,.007,4.457C423.259,420.149,423.907,420.136,424.587,420.136Z"
                              transform="translate(0 -30.844)"
                            />
                            <path
                              id="Path_11655"
                              data-name="Path 11655"
                              d="M420.777,382.235c0-.634-.006-1.268,0-1.9a2,2,0,0,1,.886-1.684.628.628,0,0,0,.233-.411,11.775,11.775,0,0,1,23.393-.875c.012.08.016.161.021.242a1.486,1.486,0,0,0,.614,1.331,1.567,1.567,0,0,1,.582,1.366c.008,1.282.019,2.564,0,3.845a1.993,1.993,0,0,1-2.818,1.805.578.578,0,0,0-.458,0,11,11,0,0,1-4.86,1.633,1.654,1.654,0,0,0-.436.219,3.512,3.512,0,0,1-.924.408,9.222,9.222,0,0,1-1.5.016,1.144,1.144,0,0,1-1.167-1.1,1.117,1.117,0,0,1,1.055-1.205,14.389,14.389,0,0,1,1.738,0,.85.85,0,0,1,.553.208.918.918,0,0,0,.942.245,9.851,9.851,0,0,0,3.721-1.276.413.413,0,0,0,.226-.512,8.388,8.388,0,0,1-.051-1.331c-.005-.958,0-1.916,0-2.874a1.982,1.982,0,0,1,.879-1.725.515.515,0,0,0,.171-.389A9.971,9.971,0,0,0,423.888,377c-.044.2-.075.4-.114.6-.1.522-.153.98.42,1.346a1.472,1.472,0,0,1,.559,1.291c0,1.322.018,2.645,0,3.967a1.921,1.921,0,0,1-1.95,1.912,1.95,1.95,0,0,1-2.017-1.9c-.023-.66,0-1.322,0-1.983Z"
                              transform="translate(-12.84)"
                            />
                          </g>
                        </svg>
                      </span>
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  {permissions && permissions.includes("mo1") ? (
                    <>
                      <li
                        className={
                          isActiveOrg ? "nav__list  active" : "nav__list"
                        }
                      >
                        <Link
                          to="/ManageOrganisation"
                          title="Manage Organisation"
                        >
                          <span className="icon icon_nav icon__mng-course">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="30"
                              height="32.65"
                              viewBox="0 0 33.633 37.767"
                            >
                              <g
                                id="clerk-with-tie"
                                transform="translate(-28.099 511.808)"
                              >
                                <path
                                  id="Path_11986"
                                  data-name="Path 11986"
                                  d="M139.355-511.778a7.151,7.151,0,0,0-3.011,1.166,7.168,7.168,0,0,0-1.542,1.564c-.177.273-.221.3-.694.391a3.432,3.432,0,0,0-2.715,2.324,4.476,4.476,0,0,0-.007,3.734,1.569,1.569,0,0,1,.184.782c0,.391-.015.428-.325.73a3.525,3.525,0,0,0-.539.708c-.192.376-.207.45-.207,1.321a3.987,3.987,0,0,0,.177,1.476,3.447,3.447,0,0,0,2.221,2.561l.406.125.443.8c1.092,1.992,1.963,3,3.077,3.549a5.5,5.5,0,0,0,2.937.657,5.5,5.5,0,0,0,2.937-.657c1.114-.546,1.985-1.557,3.077-3.549l.443-.8.406-.125a3.447,3.447,0,0,0,2.221-2.561,3.987,3.987,0,0,0,.177-1.476c0-.871-.015-.945-.207-1.321a3.328,3.328,0,0,0-.539-.708l-.325-.325-.044-1.424c-.081-3.107-.369-4.486-1.232-5.866a7.778,7.778,0,0,0-4.479-2.87A10.6,10.6,0,0,0,139.355-511.778Z"
                                  transform="translate(-94.845 0)"
                                />
                                <path
                                  id="Path_11987"
                                  data-name="Path 11987"
                                  d="M39.566-212.271c-.317.074-7.563,2.988-8.109,3.261a6.075,6.075,0,0,0-3.2,3.97,26.368,26.368,0,0,0-.14,4.036c-.03,3.261-.022,3.66.089,3.889.251.531-1.166.487,16.713.487s16.462.044,16.713-.487c.111-.229.118-.627.089-3.889a26.371,26.371,0,0,0-.14-4.036,6.075,6.075,0,0,0-3.2-3.97c-.539-.273-7.792-3.188-8.109-3.261a.84.84,0,0,0-.871.317c-.1.125-.583,1.372-1.085,2.767s-.93,2.546-.959,2.56-.125-.192-.221-.465l-.17-.494.3-.716c.391-.945.421-1.1.266-1.424-.221-.465-.3-.48-2.612-.48s-2.391.015-2.612.48c-.155.325-.125.48.266,1.424l.3.716-.17.5c-.1.273-.2.472-.229.443s-.472-1.2-.974-2.6a25.728,25.728,0,0,0-1.092-2.752A.858.858,0,0,0,39.566-212.271Zm17.075,8.582a1.114,1.114,0,0,1,.332.3c.148.2.155.3.155,1.815,0,1.424-.015,1.623-.133,1.808-.273.413-.362.421-3.726.4-3.328-.022-3.261-.015-3.512-.435a12.329,12.329,0,0,1-.007-3.534c.229-.435.221-.435,3.616-.435A19.226,19.226,0,0,1,56.641-203.689Z"
                                  transform="translate(0 -277.415)"
                                />
                              </g>
                            </svg>
                          </span>
                        </Link>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}

                  {permissions && permissions.includes("ml1") ? (
                    <>
                      <li
                        className={
                          isActiveLearner ? "nav__list active" : "nav__list"
                        }
                      >
                        <Link to="/AllLearners" title="All Learners">
                          <span className="icon icon_nav icon__lern-path">
                            <svg
                              id="Group_10768"
                              data-name="Group 10768"
                              xmlns="http://www.w3.org/2000/svg"
                              width="30"
                              height="36.19"
                              viewBox="0 0 34.454 41.017"
                            >
                              <defs>
                                <clipPath id="clipPath">
                                  <rect
                                    id="Rectangle_179"
                                    data-name="Rectangle 179"
                                    width="34.454"
                                    height="41.017"
                                  />
                                </clipPath>
                              </defs>
                              <g
                                id="Group_10841"
                                data-name="Group 10841"
                                clipPath="url(#clip-path)"
                              >
                                <path
                                  id="Path_11720"
                                  data-name="Path 11720"
                                  d="M104.912,0a17.647,17.647,0,0,1,1.764.483A6.8,6.8,0,1,1,103.244.07a1.453,1.453,0,0,0,.225-.07Z"
                                  transform="translate(-86.967)"
                                />
                                <path
                                  id="Path_11721"
                                  data-name="Path 11721"
                                  d="M42.68,195.926c-1.035-.386-2.044-.761-3.052-1.139l-8.686-3.258a1.308,1.308,0,0,1-1.065-1.517c0-.732,0-1.465,0-2.224.3-.018.579-.014.85-.055a3.453,3.453,0,0,0,3.094-3.093,21.157,21.157,0,0,0,0-4.158,3.493,3.493,0,0,0-3.6-3.136c-.093,0-.186,0-.343,0v-1.194c0-.454,0-.908,0-1.362a1.208,1.208,0,0,1,1.745-1.2q3.243,1.206,6.48,2.426c1.423.534,2.844,1.073,4.27,1.6a.41.41,0,0,1,.333.448q-.014,8.774-.008,17.549c0,.09-.01.181-.018.312"
                                  transform="translate(-26.678 -154.909)"
                                />
                                <path
                                  id="Path_11722"
                                  data-name="Path 11722"
                                  d="M184.865,187.819c0,.919.033,1.8-.011,2.675-.03.591-.469.886-.992,1.08q-3.018,1.119-6.029,2.255l-5.242,1.964c-.16.06-.323.114-.517.183-.008-.145-.02-.259-.02-.372q0-8.715-.007-17.429a.459.459,0,0,1,.356-.515q5.324-1.978,10.639-3.979a1.227,1.227,0,0,1,1.833,1.272q0,1.162,0,2.324a.281.281,0,0,1-.02.072,11.877,11.877,0,0,0-1.291.189,3.458,3.458,0,0,0-2.657,3.1,27.307,27.307,0,0,0,.005,3.963,3.541,3.541,0,0,0,3.544,3.214c.12,0,.24,0,.415,0"
                                  transform="translate(-153.627 -154.964)"
                                />
                                <path
                                  id="Path_11723"
                                  data-name="Path 11723"
                                  d="M73.643,139.032a13.5,13.5,0,0,1,4.179-2.573.548.548,0,0,1,.4.073,9.1,9.1,0,0,0,9.512.012.632.632,0,0,1,.471-.062,13.356,13.356,0,0,1,4.005,2.449.85.85,0,0,1,.091.131l-2.211.829c-2.244.843-4.487,1.692-6.737,2.52a1.064,1.064,0,0,1-.679.014c-2.9-1.07-5.79-2.16-8.683-3.246-.1-.037-.195-.082-.346-.146"
                                  transform="translate(-65.759 -121.836)"
                                />
                                <path
                                  id="Path_11724"
                                  data-name="Path 11724"
                                  d="M4.8,234.834c0,.507.006,1.015,0,1.522a1.207,1.207,0,0,1-1.262,1.259,4.043,4.043,0,0,1-2-.3,2.8,2.8,0,0,1,1.159-5.3c.307-.01.615-.013.921,0A1.193,1.193,0,0,1,4.8,233.191c.016.547,0,1.1,0,1.643"
                                  transform="translate(0 -207.164)"
                                />
                                <path
                                  id="Path_11725"
                                  data-name="Path 11725"
                                  d="M276.883,234.849c0-.508-.006-1.015,0-1.522a1.193,1.193,0,0,1,1.234-1.243,7.09,7.09,0,0,1,1.354.074,2.771,2.771,0,0,1,2.21,2.96,2.814,2.814,0,0,1-2.672,2.565c-.293.012-.588.01-.881,0a1.2,1.2,0,0,1-1.244-1.235c-.009-.534,0-1.068,0-1.6"
                                  transform="translate(-247.238 -207.236)"
                                />
                              </g>
                            </svg>
                          </span>
                        </Link>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}

                  {permissions && permissions.includes("mc1") ? (
                    <>
                      <li
                        className={
                          isActiveCourses ? "nav__list active" : "nav__list"
                        }
                      >
                        <Link to="/ManageCourses" title="Manage Courses">
                          <span className="icon icon_nav icon__lern-path">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="28.05"
                              height="26.757"
                              viewBox="0 0 28.05 26.757"
                            >
                              <g
                                id="online-course"
                                transform="translate(-11.176 488.877)"
                              >
                                <path
                                  id="Path_12961"
                                  data-name="Path 12961"
                                  d="M12.9-488.826a2.073,2.073,0,0,0-1.571,1.25l-.132.327-.017,7.934c-.006,5.222.006,8.043.046,8.249a1.978,1.978,0,0,0,1.043,1.45l.361.195,4.781.017,4.781.011-.04.573a5.12,5.12,0,0,1-1.043,3.2c-.487.527-.694.6-1.943.636-.906.029-1.061.046-1.261.155a1.471,1.471,0,0,0-.774,1.5c0,.654.115.917.487,1.095.235.115.327.115,7.7.1,7.429-.017,7.458-.017,7.613-.138.321-.241.4-.4.418-.923a1.559,1.559,0,0,0-.722-1.605c-.269-.155-.31-.161-1.307-.189-.957-.034-1.055-.046-1.359-.183a2.27,2.27,0,0,1-1.072-1.158,7.106,7.106,0,0,1-.579-2.74v-.332l4.747-.011,4.741-.017.327-.155a2.053,2.053,0,0,0,.957-.963l.149-.315v-16.567l-.195-.361a1.974,1.974,0,0,0-1.508-1.049C37.088-488.9,13.333-488.89,12.9-488.826Zm24.4,8.925.011,7.011H13.115v-6.982c0-3.841.017-7.005.04-7.022s5.457-.034,12.078-.029l12.044.017Zm-9.562,10.846a10.041,10.041,0,0,0,.315,2.15,4.557,4.557,0,0,0,.8,1.6l.264.327H21.3l.292-.321a5.887,5.887,0,0,0,1.129-3.52l.04-.573h4.97Z"
                                  transform="translate(0 0)"
                                />
                                <path
                                  id="Path_12962"
                                  data-name="Path 12962"
                                  d="M117.2-425.867c-.109.023-1.943.705-4.07,1.513a33.533,33.533,0,0,0-4,1.617.55.55,0,0,0-.132.418c0,.367.149.522.705.728l.441.166v2.809l-.166.1c-.344.189-.378.35-.378,1.657,0,1.29.029,1.422.327,1.576a1.586,1.586,0,0,0,.568.08c.384,0,.418-.011.6-.195l.195-.195v-1.215c0-1.364-.034-1.508-.378-1.725l-.195-.12v-1.255c0-.969.017-1.255.075-1.255a5.176,5.176,0,0,1,.527.189l.459.183.029,1.863a6.621,6.621,0,0,0,.126,2.047,5.2,5.2,0,0,0,2.568,1.25,11.858,11.858,0,0,0,3.29.3,9.512,9.512,0,0,0,4.133-.837c.636-.3.98-.568,1.095-.848A9.085,9.085,0,0,0,123.1-419v-1.794l1.221-.459c1.37-.516,1.588-.654,1.588-1.026a.656.656,0,0,0-.355-.625c-.1-.046-1.863-.722-3.9-1.5a37.057,37.057,0,0,0-4.225-1.519C117.41-425.913,117.306-425.89,117.2-425.867Zm4.317,2.029c2.356.894,3.795,1.473,3.795,1.519,0,.1-7.6,2.987-7.854,2.987-.149,0-3.268-1.141-5.389-1.972l-.338-.138.281-.034c.161-.017,1.45-.149,2.866-.292s2.637-.287,2.711-.315a.213.213,0,0,0,.126-.224c0-.338.12-.338-3.7.046l-3.525.361-.441-.172c-.258-.1-.447-.2-.447-.246s1.33-.585,3.806-1.525c2.092-.8,3.858-1.45,3.927-1.462a.75.75,0,0,1,.252.006C117.656-425.288,119.427-424.629,121.514-423.838Zm-10.92,5.8c.12.086.126.115.126,1.175v1.089l-.269-.017-.275-.017v-1.078c0-1,.006-1.089.109-1.164C110.427-418.151,110.439-418.146,110.594-418.037Z"
                                  transform="translate(-92.216 -59.348)"
                                />
                              </g>
                            </svg>
                          </span>
                        </Link>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}
                  <li
                    className={
                      isActiveCalendar ? "nav__list  active" : "nav__list"
                    }
                  >
                    <Link to="/Calendar" title="Calender">
                      <span className="icon icon_nav icon__mng-course">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32.109"
                          height="30.015"
                          viewBox="0 0 32.109 30.015"
                        >
                          <g id="calendar" transform="translate(-15 482)">
                            <path
                              id="Path_13435"
                              data-name="Path 13435"
                              d="M16.988-481.907a2.693,2.693,0,0,0-1.622,1.369c-.312.618-.366,1.05-.366,3.2v1.981H47.05l-.02-2.114-.02-2.107-.213-.452a3.711,3.711,0,0,0-2.473-1.881A13.185,13.185,0,0,0,42.276-482H40.661v1.509a15.387,15.387,0,0,1-.066,1.748,1.178,1.178,0,0,1-.3.465.77.77,0,0,1-.578.253.707.707,0,0,1-.578-.133c-.505-.346-.505-.339-.525-2.187L38.587-482H22.645v1.443c-.007,1.735-.04,1.955-.352,2.26a1,1,0,0,1-1.529-.173c-.14-.226-.146-.319-.166-1.888L20.578-482l-1.642.007A12.225,12.225,0,0,0,16.988-481.907Z"
                              transform="translate(0)"
                            />
                            <path
                              id="Path_13436"
                              data-name="Path 13436"
                              d="M15.013-341.447l.02,9.56.173.439a2.569,2.569,0,0,0,1.615,1.635c.319.113,1.024.12,13.934.12H44.35l.445-.153a3.661,3.661,0,0,0,2.068-1.742l.213-.432.02-9.487L47.109-351H15Zm9.354-5.744a1,1,0,0,1,.3.266c.126.173.14.293.16,1.542s.013,1.383-.106,1.655c-.233.525-.293.539-1.981.539-2.094,0-2.021.08-2.021-2.048s-.086-2.034,2.028-2.034A6.516,6.516,0,0,1,24.367-347.191Zm7.911,0a1,1,0,0,1,.3.266c.126.173.14.293.16,1.562.027,1.529-.02,1.795-.339,2.034-.179.133-.273.14-1.709.14-2.141,0-2.061.086-2.061-2.048s-.086-2.034,2.028-2.034A6.516,6.516,0,0,1,32.278-347.191Zm8.051.013c.366.193.4.346.4,1.961,0,2.134.106,2.028-2.054,2.028-1.463,0-1.509-.007-1.715-.153-.306-.219-.352-.465-.352-1.928,0-1.4.04-1.609.366-1.861.179-.14.246-.146,1.675-.146A5.275,5.275,0,0,1,40.329-347.178Zm-15.842,9.061c.306.219.352.465.352,1.895,0,1.356-.04,1.542-.359,1.841-.179.166-.186.166-1.675.186-1.416.02-1.509.013-1.715-.12-.359-.219-.379-.346-.359-2.014.02-1.482.02-1.5.179-1.669a1.022,1.022,0,0,1,.366-.239,13.223,13.223,0,0,1,1.6-.047C24.214-338.269,24.28-338.263,24.487-338.116Zm7.871-.033c.332.226.359.352.359,1.9a14.128,14.128,0,0,1-.053,1.622.65.65,0,0,1-.266.313c-.193.12-.339.133-1.7.133-2.181,0-2.087.093-2.061-2.127.02-1.509.02-1.522.179-1.689a1.022,1.022,0,0,1,.366-.239,13.223,13.223,0,0,1,1.6-.047C32-338.269,32.2-338.256,32.358-338.15Zm7.778-.086a1.161,1.161,0,0,1,.4.239l.16.173v3.244l-.186.179-.179.186H37.084l-.173-.16c-.279-.266-.319-.525-.293-2.014.027-1.941-.007-1.908,2.014-1.908A11.141,11.141,0,0,1,40.136-338.236Z"
                              transform="translate(0 -122.291)"
                            />
                          </g>
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li
                    className={
                      isActiveReports ? "nav__list  active" : "nav__list"
                    }
                  >
                    <Link to="/Reports" title="Reports">
                      <span className="icon icon_nav icon__my-courses">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32.102"
                          height="21.38"
                          viewBox="0 0 32.102 21.38"
                        >
                          <g
                            id="Group_11426"
                            data-name="Group 11426"
                            transform="translate(0)"
                          >
                            <path
                              id="Path_13250"
                              data-name="Path 13250"
                              d="M7.1-340.868a.9.9,0,0,1,.364.37c.125.245.125.351.125,9.624v9.374H9.468v-6.239c0-6.132,0-6.245.125-6.489a.84.84,0,0,1,.376-.376c.232-.119.364-.125,2.32-.125s2.088.006,2.32.125a.84.84,0,0,1,.376.376c.125.245.125.357.125,6.489v6.239h1.881v-4.514c0-4.408.006-4.527.125-4.765a.84.84,0,0,1,.376-.376c.232-.119.364-.125,2.32-.125s2.088.006,2.32.125a.84.84,0,0,1,.376.376c.119.238.125.357.125,4.765v4.514h1.881v-3.386c0-3.273.006-3.4.125-3.637a.84.84,0,0,1,.376-.376c.232-.119.364-.125,2.32-.125s2.088.006,2.32.125a.84.84,0,0,1,.376.376c.119.238.125.364.125,3.637v3.386h.6a1.672,1.672,0,0,1,.846.125.99.99,0,0,1,.5.815.99.99,0,0,1-.5.815c-.245.125-.332.125-15.549.125s-15.3,0-15.549-.125a.99.99,0,0,1-.5-.815.99.99,0,0,1,.5-.815,1.672,1.672,0,0,1,.846-.125h.6v-9.374c0-9.273,0-9.38.125-9.624a.84.84,0,0,1,.376-.376c.232-.119.364-.125,2.332-.125S6.878-340.987,7.1-340.868Z"
                              transform="translate(0 341)"
                            />
                          </g>
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname.includes("/HelpNSupport")
                        ? "nav__list  active"
                        : "nav__list"
                    }
                  >
                    <Link to="/HelpNSupport" title="Help & Support">
                      <span className="icon icon_nav icon__reports">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="38.86"
                          viewBox="0 0 28.789 37.291"
                        >
                          <g
                            id="Group_10749"
                            data-name="Group 10749"
                            transform="translate(-406.378 -367.315)"
                          >
                            <path
                              id="Path_11654"
                              data-name="Path 11654"
                              d="M424.587,420.136a.567.567,0,0,1,.02.143,1.893,1.893,0,0,0,1.244,2.2c.62.293,1.256.555,1.892.812a21.084,21.084,0,0,1,5.3,2.827,4.766,4.766,0,0,1,2.033,2.92,8.89,8.89,0,0,1,.032,2.366,2.8,2.8,0,0,1-1.355,1.931,9.919,9.919,0,0,1-3.786,1.447,42.082,42.082,0,0,1-8.334.671,56.6,56.6,0,0,1-7.918-.345,15.992,15.992,0,0,1-4.676-1.213,4.066,4.066,0,0,1-2.471-2.515,4.262,4.262,0,0,1,1-4.21,11.2,11.2,0,0,1,3.178-2.341c1.535-.809,3.111-1.54,4.669-2.306a7.5,7.5,0,0,0,.859-.446,1.8,1.8,0,0,0,.634-2.447,8.161,8.161,0,0,0-.777-1.13,13.707,13.707,0,0,1-2.886-6.461,10.179,10.179,0,0,1,.684-5.98,6.989,6.989,0,0,1,5.776-4.074,8.341,8.341,0,0,1,4.595.591,7.1,7.1,0,0,1,4.118,5.54,12.1,12.1,0,0,1-1.078,7.439.661.661,0,0,1-.37.309,7.624,7.624,0,0,1-1.1.242,1.2,1.2,0,0,1-.45-.078,10.119,10.119,0,0,0-1.309-.341,10,10,0,0,0-1.5-.008,2.229,2.229,0,0,0,.007,4.457C423.259,420.149,423.907,420.136,424.587,420.136Z"
                              transform="translate(0 -30.844)"
                            />
                            <path
                              id="Path_11655"
                              data-name="Path 11655"
                              d="M420.777,382.235c0-.634-.006-1.268,0-1.9a2,2,0,0,1,.886-1.684.628.628,0,0,0,.233-.411,11.775,11.775,0,0,1,23.393-.875c.012.08.016.161.021.242a1.486,1.486,0,0,0,.614,1.331,1.567,1.567,0,0,1,.582,1.366c.008,1.282.019,2.564,0,3.845a1.993,1.993,0,0,1-2.818,1.805.578.578,0,0,0-.458,0,11,11,0,0,1-4.86,1.633,1.654,1.654,0,0,0-.436.219,3.512,3.512,0,0,1-.924.408,9.222,9.222,0,0,1-1.5.016,1.144,1.144,0,0,1-1.167-1.1,1.117,1.117,0,0,1,1.055-1.205,14.389,14.389,0,0,1,1.738,0,.85.85,0,0,1,.553.208.918.918,0,0,0,.942.245,9.851,9.851,0,0,0,3.721-1.276.413.413,0,0,0,.226-.512,8.388,8.388,0,0,1-.051-1.331c-.005-.958,0-1.916,0-2.874a1.982,1.982,0,0,1,.879-1.725.515.515,0,0,0,.171-.389A9.971,9.971,0,0,0,423.888,377c-.044.2-.075.4-.114.6-.1.522-.153.98.42,1.346a1.472,1.472,0,0,1,.559,1.291c0,1.322.018,2.645,0,3.967a1.921,1.921,0,0,1-1.95,1.912,1.95,1.95,0,0,1-2.017-1.9c-.023-.66,0-1.322,0-1.983Z"
                              transform="translate(-12.84)"
                            />
                          </g>
                        </svg>
                      </span>
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </>
      )}
    </>
  );
};

export default Sidebar;
